export const firstToLower = (str?: string) =>
  (str && `${str[0].toLocaleLowerCase()}${str.slice(1)}`) || str;
